import { IRowCards, IItem, RowCardsProps } from './types';

export const mapRowCards = ({
  prismicContent,
}: {
  prismicContent: RowCardsProps['slice'];
}): IRowCards => {
  const items: IItem[] = prismicContent.items.map(
    ({
      bgcolor: bgColor,
      title,
      title_style: titleStyle,
      text,
      text_alignment: textAlignment,
      img,
      is_cta_displayed: isCtaDisplayed,
      cta_label: ctaLabel,
      cta_link: ctaLink,
      reverse,
    }) => ({
      title,
      titleStyle,
      text,
      textAlignment,
      img,
      reverse,
      isCtaDisplayed,
      ctaLabel: ctaLabel as string,
      ctaLink,
      bgColor: bgColor as string,
    }),
  );

  const {
    title,
    title_style: titleStyle,
    title_decoration: titleDecoration,
    overflow_behavior: overflowBehavior,
  } = prismicContent.primary;

  const rowCards: IRowCards = {
    title,
    titleStyle,
    titleDecoration,
    items,
    overflowBehavior,
  };

  return rowCards;
};
